/**
 * Chuỗi của màn Lịch sử luồng chạy (`/rpa/history`), Dữ liệu thực thi (`/rpa/history/execution-data`) và Báo cáo lỗi
 * & Sự cố (`/rpa/incidents`) — namespace `rpa.history`, `rpa.executionData`, `rpa.runDetail`, `rpa.robotLog`,
 * `rpa.incidents` của web-portal native, đổi sang kiểu dấu thanh mới. Tạm tách tệp, sẽ gộp vào `vi.ts`.
 */
export const viRpaLichSu = {
  rpaLichSu: {
    moTa: 'Lượt chạy OpenRPA lưu tại Native, đồng bộ từ OpenCore và giữ cả lượt cũ OpenCore đã xoá, kèm báo cáo lỗi và log Robot gửi về.',
    tim: 'Tìm luồng / ID / InstanceId / trạng thái / máy...',
    locTrangThai: 'Lọc theo trạng thái',
    moiTrangThai: 'Mọi trạng thái',
    nguon: 'Lưu tại Native · {{tong}} lượt chạy · đồng bộ OpenCore lúc {{luc}}',
    dangDongBo: 'đang đồng bộ...',
    nguonLoi: 'Chưa đồng bộ được OpenCore: đang hiện {{tong}} lượt đã lưu tại Native, có thể thiếu lượt mới nhất.',
    tongTrang: '{{tu}}–{{den}} / {{tong}} lượt chạy',
    rong: 'Chưa có lượt chạy nào',
    rongMoTa: 'Lượt chạy OpenRPA hiện ở đây sau khi Robot chạy Workflow và máy chủ đồng bộ từ OpenCore.',
    rongLoc: 'Không có lượt chạy nào khớp bộ lọc',
    cotThoiGian: 'Thời gian chạy',
    cotLuot: 'Luồng chạy / ID',
    cotTrangThai: 'Trạng thái',
    cotKetThuc: 'Thời gian kết thúc',
    cotKiemLoi: 'Kiểm tra lỗi',
    cotLogRobot: 'Log Robot',
    cotDuLieu: 'Dữ liệu thực thi',
    xemLoi: 'Xem lỗi ({{so}})',
    xemLog: 'Xem log',
    xemDuLieu: 'Xem dữ liệu',
    hopLoiTieuDe: 'Báo cáo lỗi · {{ten}}',
    xemLogRobot: 'Xem log Robot',
    dongThoiGianTieuDe: 'Dòng thời gian lượt chạy · {{ma}}',
    dongThoiGianRong: 'Lượt chạy này chưa có mốc nào.',
    instanceId: 'Instance ID (OpenCore)',
    trangThaiInstance: 'Trạng thái instance',
    may: 'Máy',
    trangThai: {
      completed: 'Thành công',
      failed: 'Lỗi',
      timeout: 'Quá thời gian',
      running: 'Đang chạy',
      idle: 'Chờ',
      aborted: 'Đã huỷ',
    },
  },
  rpaBaoCao: {
    tieuDe: 'Báo cáo lỗi từ Robot',
    chuaCo: 'Robot chưa gửi báo cáo lỗi cho lượt chạy này. Robot gửi báo cáo ở nền nên báo cáo có thể đến sau khi lượt chạy kết thúc.',
    capNhat: 'Cập nhật {{luc}} · lần gửi {{lan}} · executionId {{ma}}',
    xemDongThoiGian: 'Xem dòng thời gian',
    khongCoLoi: 'Báo cáo không có lỗi nào.',
    cotLoi: 'Bước lỗi',
    cotVideo: 'Video',
    cotAnh: 'Ảnh',
    cotLog: 'Log',
    chiTietLoi: 'Chi tiết lỗi',
    tepChung: 'Tệp dùng chung',
    chuaCoTenBuoc: 'Chưa có tên bước',
    chuaCoTep: 'Chưa có',
    xemAnh: 'Xem ảnh',
    xemVideo: 'Xem video',
    xemLog: 'Xem log',
    hopTepTieuDe: '{{loai}} · {{ten}}',
    taiVe: 'Tải về',
    chuaCoVideo: 'Chưa có video. Robot gửi video sau khi lượt chạy kết thúc.',
    ghiChuLuuTru: 'Ảnh và video lưu ở kho tệp, log lưu trong cơ sở dữ liệu của module; tệp tự xoá sau thời gian giữ lại máy chủ cấu hình.',
    maLoi: 'Mã lỗi: {{ma}}',
    lanThu: 'Lần thử: {{lan}}',
    chuaThuocLoai: '{{ten}} · chưa thuộc loại lỗi nào',
    nguyenNhan: 'Nguyên nhân',
    heThongXuLy: 'Hệ thống xử lý',
    nhomLoi: 'Nhóm lỗi',
    thuLai: 'Thử lại {{lan}} lần, cách {{giay}} giây',
    khongThuLai: 'Không thử lại',
    hetLanBoQua: 'Hết lần thì bỏ qua và báo',
    hetLanDung: 'Hết lần thì dừng lượt chạy',
    chuaPhanLoai:
      'Lỗi này chưa thuộc loại lỗi nào ở Cấu hình lỗi. Xem thông báo gốc và chi tiết exception để biết nguyên nhân, rồi gán exception vào một loại lỗi.',
    thongBaoGoc: 'Thông báo gốc từ Robot',
    khongCoThongBao: 'Robot không gửi thông báo lỗi.',
    chiTietException: 'Chi tiết exception',
  },
  rpaLogRobot: {
    tieuDe: 'Log Robot · {{ten}}',
    chep: 'Sao chép',
    daChep: 'Đã sao chép log.',
    khongChepDuoc: 'Trình duyệt không cho sao chép ở trang này. Dùng nút Tải về để lấy log.',
    taiVe: 'Tải về',
    thieuTieuDe: 'Thiếu log.',
    chuaCo:
      'Robot chưa gửi log cho lượt chạy này. Log được gửi ở cuối lượt chạy nên có thể đến sau; lượt đã kết thúc lâu mà vẫn chưa có thì kiểm tra bước gửi log trong Workflow.',
    khongCoInstance: 'Lượt chạy này không có InstanceId nên không gắn được log Robot gửi về.',
    workflow: 'Workflow',
    may: 'Máy',
    taiLenLuc: 'Tải lên lúc',
    dungLuong: 'Dung lượng',
    dungLuongGiaTri: '{{dong}} dòng · {{kyTu}} ký tự',
    vungLog: 'Nội dung log Robot',
    ghiChu: 'Máy chủ đã che token và mật khẩu trong log. Log cũ tự xoá sau thời gian giữ lại.',
  },
  rpaDuLieu: {
    tieuDe: 'Chi tiết dữ liệu thực thi',
    phuDe: '{{luong}} · Mã lượt: {{ma}}',
    chuaRoLuong: 'Chưa rõ tên luồng',
    quayLai: 'Quay lại Lịch sử',
    khongCoInstance: 'Lượt chạy này chưa có InstanceId nên chưa gắn được dữ liệu thực thi.',
    soCao: 'Dữ liệu cào',
    soXuLy: 'Dữ liệu xử lý',
    dong: 'dòng dữ liệu',
    tinhTrang: {
      match: 'Khớp',
      missing: 'Thiếu dữ liệu',
      extra: 'Dư dữ liệu',
      empty: 'Chưa có dữ liệu thực thi cho lượt chạy này.',
    },
    chiTiet: {
      match: 'đã xử lý đủ {{xuLy}}/{{cao}} dòng đã cào.',
      missing: 'thiếu {{lech}} dòng: đã cào {{cao}}, chỉ xử lý {{xuLy}}. Mở tab Đối chiếu để biết dòng nào bị thiếu.',
      extra: 'dư {{lech}} dòng: đã cào {{cao}}, nhưng xử lý {{xuLy}}. Mở tab Đối chiếu để xem dòng dư.',
    },
    tab: {
      crawled: 'Bảng dữ liệu cào',
      processed: 'Bảng dữ liệu xử lý',
      compare: 'Đối chiếu thiếu / dư',
      scrape: 'Kết quả cào',
    },
    tim: 'Tìm trong dữ liệu...',
    timTrong: 'Tìm trong {{ten}}',
    xuatJson: 'Xuất JSON',
    xuatCsv: 'Xuất CSV',
    daXuat: 'Đã xuất {{so}} dòng.',
    cotJson: 'JSON gốc',
    xemJson: 'Xem JSON gốc của dòng {{dong}}',
    jsonTieuDe: 'JSON gốc · dòng {{dong}}',
    tongTrang: '{{tu}}–{{den}} / {{tong}} dòng',
    rongLoc: 'Không có dòng nào khớp từ khoá',
    rong: {
      crawled: 'Chưa có dữ liệu cào cho lượt chạy này',
      processed: 'Chưa có dữ liệu xử lý cho lượt chạy này',
    },
    rongMoTa: 'Robot gửi dữ liệu thực thi trong lúc chạy; bấm Làm mới để tải lại.',
    cotGhepNhan: 'Cột dùng để ghép dòng cào với dòng xử lý',
    cotGhepMacDinh: 'Tất cả cột chung (mặc định)',
    cotGhep: 'Cột dùng để ghép',
    dangGhepTheo: 'Đang ghép theo: {{cot}}. Cột đánh dấu ★ trong bảng là cột ghép.',
    khongCoCotChung: 'Hai bảng không có cột chung để ghép: mọi dòng cào được tính là thiếu.',
    cotBiBo:
      'Tự bỏ khỏi cột ghép (cột thời điểm hoặc bị thay đổi khi xử lý): {{cot}}. Muốn ghép theo các cột này thì chọn ở ô trên.',
    soKhop: 'Khớp: {{so}}',
    soThieu: 'Thiếu: {{so}}',
    soDu: 'Dư: {{so}}',
    thieuTieuDe: 'Dòng thiếu ({{so}}): đã cào nhưng không có trong dữ liệu xử lý',
    duTieuDe: 'Dòng dư ({{so}}): có trong dữ liệu xử lý nhưng không có trong dữ liệu cào',
    khongThieu: 'Không thiếu dòng nào.',
    khongDu: 'Không có dòng dư.',
    lechBiCat: 'Đang hiện {{hien}} / {{tong}} dòng đầu.',
    caoKhongCoMa: 'Lượt chạy này chưa có mã executionId nên chưa tra được kết quả cào.',
    caoRong: 'Chưa có kết quả cào cho lượt chạy này',
    caoRongMoTa: 'Kết quả cào dạng thẻ chỉ có khi Workflow gửi về bước cào kết quả.',
    caoLocNhan: 'Lọc theo nhãn',
    caoMoiNhan: 'Mọi nhãn',
    caoViTri: 'Vị trí',
    caoNhan: 'Nhãn',
    caoNoiDung: 'Nội dung',
    caoNguon: 'Trang nguồn',
    caoLuc: 'Thời điểm cào',
  },
  rpaSuCo: {
    moTa: 'Sự cố 30 ngày gần nhất: lỗi Robot báo về theo danh mục lỗi đã cấu hình, instance lỗi trên OpenCore và lượt chạy FOXAI thất bại.',
    tim: 'Tìm luồng, Project, máy, thông báo lỗi...',
    locKhoang: 'Khoảng thời gian',
    soNgay: '{{so}} ngày',
    locNguon: 'Lọc theo nguồn',
    moiNguon: 'Mọi nguồn',
    locProject: 'Lọc theo Project',
    moiProject: 'Mọi Project',
    locMucDo: 'Lọc theo mức độ',
    moiMucDo: 'Mọi mức độ',
    locLoai: 'Lọc theo loại lỗi',
    moiLoai: 'Mọi loại lỗi',
    boLoc: 'Bỏ lọc',
    xuatCsv: 'Xuất CSV',
    daXuat: 'Đã xuất {{so}} sự cố.',
    daTai: '{{so}} sự cố trong 30 ngày (tối đa 500 dòng mỗi nguồn). Lỗi Robot báo về lấy mã và mức độ theo danh mục lỗi; sự cố còn lại FOXAI tự xếp theo loại lỗi.',
    biCat: 'Kết quả đã chạm giới hạn, chưa đại diện cho toàn bộ kỳ.',
    opencoreLoi: 'Không đọc được OpenCore: chỉ hiện lỗi Robot báo về và lượt chạy FOXAI.',
    rong: 'Không có sự cố nào trong 30 ngày',
    rongMoTa: 'Lượt chạy lỗi, bị huỷ và lỗi Robot báo về sẽ hiện ở đây.',
    rongKy: 'Không có sự cố trong kỳ đã chọn.',
    rongLoc: 'Không có sự cố nào khớp bộ lọc',
    kpiTong: 'Sự cố trong dữ liệu đã tải',
    kpiLoi: 'Lượt chạy lỗi',
    kpiHuy: 'Đã huỷ',
    kpiMttr: 'MTTR',
    mttrChuaCo: 'Chưa có dữ liệu nguồn',
    theoNguonLoi: 'Phân bố nguồn lỗi',
    trongDuLieu: 'Trong dữ liệu đã tải',
    theoMucDo: 'Phân bố theo mức độ',
    theoMucDoGoiY: 'Theo danh mục lỗi; lỗi không có mã do FOXAI tự xếp',
    suCoGiua: 'sự cố',
    theoNgay: 'Sự cố theo ngày',
    theoNgayGoiY: 'Số lượt chạy lỗi / huỷ theo nguồn',
    theoGio: 'Phân bố sự cố theo khung giờ',
    gio: '{{gio}}:00–{{den}}:00',
    tong: 'Tổng',
    moTaCot: '{{cot}}: {{so}} sự cố',
    soSuCoThe: '{{so}} sự cố',
    theoProject: 'Sự cố theo Project và nguồn lỗi',
    moTaProject: '{{project}}: {{chiTiet}}',
    chuaCoProject: 'Chưa xác định Project',
    projectKhac: 'Khác',
    chuaXacDinh: 'Chưa xác định',
    danhSachLoi: 'Danh sách lỗi',
    tomTatLoai: 'Lường trước: {{luongTruoc}} loại · Bất ngờ: {{batNgo}} loại',
    cotLoi: 'Mã / Tên lỗi',
    cotLoai: 'Loại lỗi',
    cotMucDo: 'Mức độ',
    cotSoLan: 'Số lần',
    cotSoLuong: 'Số luồng',
    cotGanNhat: 'Gần nhất',
    dongThoiGian: 'Dòng thời gian sự cố gần đây',
    nhatKy: 'Nhật ký sự cố chi tiết',
    soSuCo: '{{so}} sự cố',
    cotThoiDiem: 'Thời điểm',
    cotProject: 'Project',
    cotWorkflow: 'Luồng',
    cotNguon: 'Nguồn lỗi',
    cotThongBao: 'Thông báo lỗi',
    cotTrangThai: 'Trạng thái chạy',
    khongCoThongBao: 'Chưa có thông báo lỗi',
    xemChiTietCua: 'Xem chi tiết sự cố của {{ten}}',
    chiTietTieuDe: 'Chi tiết sự cố',
    nguon: {
      foxai: 'FOXAI',
      opencore: 'OpenCore',
      robot: 'Robot',
    },
    ct: {
      thoiGian: 'Thời gian',
      mucDo: 'Mức độ',
      project: 'Project',
      loai: 'Loại lỗi',
      maLoi: 'Mã / Tên lỗi',
      nhomLoi: 'Nhóm lỗi',
      workflow: 'Workflow',
      may: 'Máy',
      buoc: 'Bước gặp lỗi',
      nguonLoi: 'Nguồn lỗi',
      id: 'ID',
      loiDayDu: 'Lỗi đầy đủ',
    },
    csv: {
      id: 'ID',
      thoiGian: 'Thời gian',
      project: 'Project',
      workflow: 'Workflow',
      may: 'Máy',
      nguon: 'Nguồn',
      maLoi: 'Mã / Tên lỗi',
      loai: 'Loại lỗi',
      nguonLoi: 'Nguồn lỗi',
      mucDo: 'Mức độ',
      thongBao: 'Thông báo',
      trangThai: 'Trạng thái',
    },
    loiNgan: {
      elementNotFound: 'Không tìm thấy phần tử giao diện',
      nullReference: 'Biến hoặc đối tượng chưa có dữ liệu',
      nullValue: 'Thiếu giá trị đầu vào',
      missingRead: 'Tài khoản chưa có quyền Read',
      unknownWorkflow: 'Robot không thấy Workflow',
      unknownQueue: 'Không tìm thấy Robot / Queue',
      channelClosed: 'Mất kết nối tới Robot',
      invokeFailed: 'Gọi Robot thất bại',
      licenseNotFound: 'Không tìm thấy License',
      databaseConnection: 'Không kết nối được cơ sở dữ liệu',
      libraryLoad: 'Lỗi nạp thư viện OpenIAP',
      userStopped: 'Người dùng dừng',
      accessDenied: 'Không có quyền truy cập',
      timeout: 'Quá thời gian chờ',
    },
  },
} as const;
